<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商城管理</el-breadcrumb-item>
        <el-breadcrumb-item>商城订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form
        ref="listForm"
        :model="listParams"
        label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单状态：" prop="orderStatus">
              <el-select
                placeholder="请选择订单状态"
                size="small"
                v-model="listParams.orderStatus"
                style="width: 100%;"
                clearable>
                <el-option
                  v-for="item in orderStatusList"
                  :label="item.title"
                  :value="item.id"
                  :key="item.title">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="日期查询：" prop="timeInterval">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="用户账号：" prop="userAccount">
              <el-input
                size="small"
                v-model="listParams.userAccount"
                placeholder="请输入用户账号">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="用户手机号：" prop="phoneNumber">
              <el-input
                size="small"
                v-model="listParams.phoneNumber"
                placeholder="请输入用户手机号">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                @click="loadTableData">
                查询
              </el-button>

              <el-button
                size="small"
                @click="resetFields('listForm')">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange">

      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table
        slot="content"
        :data="tableData"
        max-height="800"
        border>
        <el-table-column
          width="80"
          align="center"
          label="序号">
          <template slot-scope="scope">
            <span
              v-text="(pager.pageIndex > 1 ?
               (pager.pageIndex-1) * pager.pageSize :
               0) + scope.$index + 1">
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="userAccount"
          align="center"
          label="用户账号">
        </el-table-column>

        <el-table-column
          prop="orderDate"
          align="center"
          label="下单日期">
          <template slot-scope="scope">
            {{ scope.row.orderDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column
          prop="goodsNumber"
          align="center"
          label="商品数量">
        </el-table-column>

        <el-table-column
          prop="orderAmount"
          align="center"
          label="订单金额(元)">
          <template slot-scope="scope">
            ￥{{ scope.row.orderAmount | formatToFixed2 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="orderStatusDisplay"
          align="center"
          label="订单状态">
        </el-table-column>

        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <confirm-button
              v-if="scope.row.orderStatusValue === 2"
              type="text"
              style="margin: 0 10px;"
              title="确认要发货吗？"
              @confirmed="deliverItem(scope.row.orderId)">
              <span>发货</span>
            </confirm-button>

            <confirm-button
              v-if="scope.row.orderStatusValue === 3"
              type="text"
              style="margin: 0 10px;"
              title="确认要收货吗？"
              @confirmed="receiveItem(scope.row.orderId)">
              <span>收货</span>
            </confirm-button>

            <el-button
              type="text"
              @click="linkToDetailPage(scope.row.orderId)">
              订单详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data () {
    return {
      listParams: {
        orderStatus: '',
        timeInterval: ['', ''],
        userAccount: '',
        phoneNumber: ''
      },
      orderStatusList: [
        { id: 0, title: '已取消' },
        { id: 1, title: '待付款' },
        { id: 2, title: '待发货' },
        { id: 3, title: '待收货' },
        { id: 7, title: '已完成' },
        { id: 8, title: '交易关闭' },
        { id: 9, title: '交易过期' }
      ],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      tableData: [],
      tableLoading: false,
      oldBodyParams: {},
      pagerChanged: false
    };
  },
  mounted () {
    this.loadTableData();
  },
  methods: {
    /**
       * 加载table列表
       */
    loadTableData () {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      bodyParams.startDate = bodyParams.timeInterval[0];
      bodyParams.endDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      const flag = this.checkParamsIsNotChanged(bodyParams, this.oldBodyParams);
      if (!flag) {
        bodyParams.pageIndex = 1;
        this.pager.pageIndex = 1;
      } else {
        bodyParams.pageIndex = this.pager.pageIndex;
      }
      if (this.pagerChanged) {
        bodyParams.pageIndex = this.pager.pageIndex;
      }
      Vue.ajaxGet(this, global.apiUrl + '/order/mall/list', bodyParams, 'tableLoading').then((res) => {
        this.tableData = res.dataList;
        this.pager.total = res.total;
        this.oldBodyParams = bodyParams;
      });
    },
    /**
       * 重置表单
       * @param name
       */
    resetFields (name) {
      this.$refs[name].resetFields();
    },
    /**
       * pageIndex的change事件
       * @param val
       */
    handleCurrentChange (val) {
      this.pager.pageIndex = val;
      this.pagerChanged = true;
      this.loadTableData();
    },
    /**
       * pageSize的change事件
       * @param val
       */
    handleSizeChange (val) {
      this.pager.pageSize = val;
      this.pagerChanged = true;
      this.loadTableData();
    },
    /**
       * 发货
       * @param orderId
       */
    deliverItem (orderId) {
      Vue.ajaxPost(this, global.apiUrl + '/order/mall/send', { orderId: orderId }, true, true).then((res) => {
        this.$message.success(res.info);
        this.loadTableData();
      });
    },
    /**
       * 收货
       * @param orderId
       */
    receiveItem (orderId) {
      Vue.ajaxPost(this, global.apiUrl + '/order/mall/receive', { orderId: orderId }, true, true).then((res) => {
        this.$message.success(res.info);
        this.loadTableData();
      });
    },
    /**
       * 跳转至详情页
       * @param orderId
       */
    linkToDetailPage (orderId) {
      this.$router.push({
        name: 'mallOrderDetail',
        query: {
          orderId: orderId
        }
      });
    },
    /**
       * 检测表单参数是否改变
       * @param val
       * @param oldVal
       * @returns {boolean}
       */
    checkParamsIsNotChanged (val, oldVal) {
      if (!this.checkIsEmptyObj(oldVal)) {
        for (const i in val) {
          if (i !== 'pageIndex' && i !== 'pageSize') {
            if (val[i] !== oldVal[i]) {
              return false;
            }
          }
        }
        return true;
      } else {
        return true;
      }
    },
    /**
       * 检测是否为空对象
       * @param obj
       * @returns {boolean}
       */
    checkIsEmptyObj (obj) {
      for (const i in obj) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
  .home-container{
    .alert-text{
      color: #E9A021;
      cursor: default;
    }
  }
</style>
